import {
    CheckCircle2,
    Circle,
    ArrowRight
} from "lucide-react";

import Card from "../shared/Card";
import Button from "../shared/Button";

import {
    LEAD_STATUSES
} from "../../constants/statuses";

export default function StatusCard({

    lead,

    onUpdate,

    loading

}){

    if(!lead){

        return null;

    }

    const currentIndex =

        LEAD_STATUSES.findIndex(

            status=>

                status.value===lead.status

        );

    const progress =

        ((currentIndex + 1) /

        LEAD_STATUSES.length) * 100;

    return(

        <Card className="crm-status-card">

            <div className="crm-card-title">

                Lead Progress

            </div>

            <div className="crm-progress">

                <div

                    className="crm-progress-bar"

                    style={{

                        width:`${progress}%`

                    }}

                />

            </div>

            <div className="crm-status-list">

                {

                    LEAD_STATUSES.map(

                        (status,index)=>{

                            const completed=

                                index<currentIndex;

                            const active=

                                index===currentIndex;

                            return(

                                <div

                                    key={status.value}

                                    className={`
                                        crm-status-item
                                        ${completed?"completed":""}
                                        ${active?"active":""}
                                    `}

                                >

                                    <div className="crm-status-icon">

                                        {

                                            completed

                                            ?

                                            <CheckCircle2 size={18}/>

                                            :

                                            <Circle size={18}/>

                                        }

                                    </div>

                                    <div className="crm-status-content">

                                        <div>

                                            {status.label}

                                        </div>

                                    </div>

                                </div>

                            );

                        }

                    )

                }

            </div>

            {

                currentIndex <

                LEAD_STATUSES.length-1 &&

                <Button

                    loading={loading}

                    icon={<ArrowRight size={16}/>}

                    onClick={()=>

                        onUpdate(

                            LEAD_STATUSES[

                                currentIndex+1

                            ].value

                        )

                    }

                >

                    Move to {

                        LEAD_STATUSES[

                            currentIndex+1

                        ].label

                    }

                </Button>

            }

<style>{`

.crm-status-card{

    display:flex;

    flex-direction:column;

    gap:20px;

}

.crm-progress{

    width:100%;

    height:6px;

    background:#E2E8F0;

    border-radius:999px;

    overflow:hidden;

}

.crm-progress-bar{

    height:100%;

    background:#2563EB;

    transition:.25s;

}

.crm-status-list{

    display:flex;

    flex-direction:column;

    gap:18px;

}

.crm-status-item{

    display:flex;

    align-items:center;

    gap:14px;

    color:#94A3B8;

    position:relative;

}

.crm-status-item:not(:last-child)::after{

    content:"";

    position:absolute;

    left:8px;

    top:26px;

    width:2px;

    height:26px;

    background:#E2E8F0;

}

.crm-status-icon{

    width:18px;

    display:flex;

    justify-content:center;

    flex-shrink:0;

}

.crm-status-item.completed{

    color:#16A34A;

}

.crm-status-item.completed svg{

    color:#16A34A;

}

.crm-status-item.active{

    color:#2563EB;

    font-weight:600;

}

.crm-status-item.active svg{

    color:#2563EB;

}

.crm-status-content{

    display:flex;

    flex-direction:column;

    gap:2px;

}

`}</style>

        </Card>

    );

}